import { env, isDevelopment } from './env';
import { webConfig } from './webConfig';

/**
 * Return the fully qualified API url with protocol.
 */
export function getAPIEndpoint(forceDeployed = false): string {
    if (!forceDeployed && (isDevelopment || env === 'test')) {
        return 'http://api.localhost:7000';
    }

    return `https://${webConfig.services.api.host}`;
}
